import { Box } from '@mui/material';
import React from 'react';
import getDuration from 'utils/getDuration';
import PlaceSharpIcon from '@mui/icons-material/PlaceSharp';
import ElectricalServicesTwoToneIcon from '@mui/icons-material/ElectricalServicesTwoTone';
import SensorsTwoToneIcon from '@mui/icons-material/SensorsTwoTone';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import SpeedTwoToneIcon from '@mui/icons-material/SpeedTwoTone';
import SignalCellular1BarTwoToneIcon from '@mui/icons-material/SignalCellular1BarTwoTone';
import { PointTagDataInterface } from 'modules/Telematics/types';
interface Props {
	machineData: PointTagDataInterface;
}
const PrunedPointInfoWindow = ({ machineData }: Props) => {
	const machineId = machineData.machineNumber;
	const logReason = machineData.LogReason;

	const lastConnected = Date.now() / 1000 - machineData.TimeStamp;
	const lastConnectedStringValue = `${getDuration(lastConnected)} ago`;
	const lat = machineData.Latitude;
	const lng = machineData.Longitude;
	const bearing = machineData.HeadingDegrees;
	const tehsil = machineData.Tehsil;
	const district = machineData.District;
	const state = machineData.State;
	const location = `${tehsil}, ${district}, ${state}`;
	const locationAvailable = tehsil && district && state;
	const batteryPercentage = machineData.BatteryPercentage;
	const batteryVoltage = machineData.InternalBatteryVoltage;
	const batteryTemp = machineData.InternalTemp;
	const loadedBatteryVoltage = machineData.LoadedBatteryVoltage;
	const batterySupply = Boolean(machineData.SupplyGood);
	const externalPowerConnected = Boolean(machineData.ExternalPowerConnected);
	const externalVoltage = machineData.ExternalVoltage;
	const ignitionOn = Boolean(machineData.IgnitionOn);
	const engineOn = Boolean(machineData.EngineOn);
	const sprayerOn = Boolean(machineData.SprayerOn);
	const speed = machineData.Speed;
	const odometer = machineData.OdometerInKm;
	const cellular = machineData.GsmSignalStrength;
	return (
		<Box
			sx={{
				width: '400px ',
				border: '1px soild lightgrey',
				borderRadius: '5px',
			}}
		>
			<Box
				id="header"
				sx={{
					display: 'flex',
					background: 'lightgrey',
					height: '40px',
					alignItems: 'center',
				}}
			>
				<Box sx={{ marginLeft: '10px' }} id="machine-id">
					{machineId}
				</Box>
			</Box>
			<Box
				sx={{
					padding: '10px',
					'&>div': {
						border: '1px solid lightgrey',
						borderRadius: '5px',
						marginTop: '10px',
						padding: '10px',
						alignItems: 'center',
					},
				}}
				id="content"
			>
				<Box>
					{logReason}, {lastConnectedStringValue}
				</Box>
				<Box id="location">
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							flexWrap: 'wrap',
						}}
					>
						<PlaceSharpIcon />
						<Box marginLeft="5px">
							{lat} , {lng}
						</Box>
						<Box marginLeft="5px">accurate by 5 mts</Box>
					</Box>
					<Box>Bearing : {bearing} deg C</Box>
					{locationAvailable && <Box>Located at: {location}</Box>}
				</Box>
				<Box id="power">
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						Power <ElectricalServicesTwoToneIcon />
						<Box marginLeft="5px">{batteryPercentage}%</Box>
					</Box>
					<Box
						sx={{
							display: 'flex',
							marginTop: '5px',
						}}
					>
						<Box>Battery: {batteryVoltage}V</Box>
						<Box marginLeft="10px">Temp: {batteryTemp} deg C</Box>
					</Box>
					<Box
						sx={{
							display: 'flex',
						}}
					>
						<Box>Load: {loadedBatteryVoltage}V</Box>
						<Box marginLeft="10px">
							Supply Good: {batterySupply ? 'True' : 'False'}
						</Box>
					</Box>
					<Box
						sx={{
							display: 'flex',
						}}
					>
						<Box>
							Ext Power: {externalPowerConnected ? 'On' : 'Off'}
						</Box>
						<Box marginLeft="10px">Voltage: {externalVoltage}V</Box>
					</Box>
				</Box>
				<Box id="sensors">
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						Sensors
						<SensorsTwoToneIcon sx={{ marginLeft: '5px' }} />
					</Box>
					<FormGroup>
						<FormControlLabel
							control={
								<Switch size="small" checked={ignitionOn} />
							}
							label="Ignition On"
						/>
					</FormGroup>
					<FormGroup>
						<FormControlLabel
							control={<Switch size="small" checked={engineOn} />}
							label="Engine On"
						/>
					</FormGroup>
					<FormGroup>
						<FormControlLabel
							control={
								<Switch size="small" checked={sprayerOn} />
							}
							label="Sprayer On"
						/>
					</FormGroup>
				</Box>
				<Box id="movement">
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						Movement <SpeedTwoToneIcon sx={{ marginLeft: '5px' }} />
					</Box>
					<Box display="flex" alignItems="center">
						<Box>Speed: {speed} kmph</Box>
						<Box marginLeft="5px">Odo: {odometer} kms</Box>
					</Box>
				</Box>
				<Box id="cellular-strength">
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						Cellular strength{' '}
						<SignalCellular1BarTwoToneIcon
							sx={{ marginLeft: '5px' }}
						/>
						: {cellular}%
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
export default PrunedPointInfoWindow;
